import { Routes } from '@angular/router';
import { EMAIL_MSG_TEMPLATE_CONFIG } from './base/email-msg-template-config';

export const emailMsgTemplateRoutes: Routes = [
  {
    path: EMAIL_MSG_TEMPLATE_CONFIG.routePath,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/email-msg-template-list-page/email-msg-template-list-page.component'
          ).then((m) => m.EmailMsgTemplateListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/email-msg-template-detail-page/email-msg-template-detail-page.component'
              ).then((m) => m.EmailMsgTemplateDetailPageComponent),
          },
        ],
      },
    ],
  },
];
